class InfoCardCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bookmarked = options?.bookmarked ? false
        @.buttons = options?.buttons ? []
        @.dontRenderBookmark = options?.dontRenderBookmark ? false
        @.headline = options?.headline ? 'n/a'
        @.kicker = options?.kicker ? 'n/a'
        @.mediaType = options?.mediaType ? false
        @.publishDate = options?.publishDate ? false
        @.tag = options?.tag ? 'div'
        @.tags = options?.tags ? []
        @.targetGroup = options?.targetGroup ? false
        @.topic = options?.topic ? false
        @.text = options?.text ? ''

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        self = @
        @.$el = document.createElement @.tag
        @.$el.classList.add 'info-card'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.mediaType
            @.$el.dataset.mediaType = @.mediaType
        if @.targetGroup
            @.$el.dataset.targetGroup = @.targetGroup
        if @.topic
            @.$el.dataset.topic = @.topic
        if @.publishDate
            @.$el.dataset.publishDate = @.publishDate
        @.$el.innerHTML = "
            <div class='info-card__header'>
            </div>
            #{ if @.tags.length > 0 then "<div class='info-card__tags'></div>" else "" }
            <div class='info-card__text'>#{ @.text }</div>
            #{ if @.buttons.length > 0 then "<div class='info-card__buttons'></div>" else "" }
        "
        if !@.dontRenderBookmark
            @.$el.querySelector '.info-card__header'
                .appendChild window.CreateBookmark {
                    attrs: {
                        class: ['info-card__bookmark']
                    }
                    marked: @.bookmarked
                }
        @.$el.querySelector '.info-card__header'
            .innerHTML += "
                <div class='kicker info-card__kicker'>#{ @.kicker }</div>
                <h3 class='headline headline--4 info-card__headline'>#{ @headline }</h3>
            "
        @.tags.forEach (tag) ->
            self.$el.querySelector '.info-card__tags'
                .appendChild window.CreateTag {
                    iconBlack: true
                    link: tag.link ? false
                    text: tag.text
                }
            return
        @.buttons.forEach (button) ->
            buttonContainer = document.createElement 'div'
            buttonContainer.classList.add 'info-card__button'
            buttonContainer.appendChild window.CreateButton {
                download: button.download ? false,
                link: button.link ? false
                outline: button.outline ? false
                primary: button.primary ? false
                target: button.target ? false
                text: button.text
            }
            self.$el.querySelector '.info-card__buttons'
                .appendChild buttonContainer
        return

window.CreateInfoCard = (options) ->
    return new InfoCardCreate options